import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useI18n } from '../context/I18nContext';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ChevronDown } from 'lucide-react';

export default function FAQPage() {
  const { t } = useI18n();
  const items = t('faq.items') || [];
  const licensingFaq = t('licensing.faq') || [];
  const [openIndex, setOpenIndex] = useState(null);

  const allFaqs = [...(Array.isArray(items) ? items : []), ...(Array.isArray(licensingFaq) ? licensingFaq : [])];

  return (
    <div className="min-h-screen bg-background" data-testid="faq-page">
      <Navbar />
      <section className="pt-32 pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-12"
          >
            <h1
              className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-foreground mb-4"
              data-testid="faq-page-title"
            >
              {t('faq.title')}
            </h1>
            <p className="text-muted-foreground text-base md:text-lg">
              {t('faq.tag')}
            </p>
          </motion.div>

          <div className="space-y-2">
            {allFaqs.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.04 }}
                data-testid={`faq-page-item-${i}`}
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between p-5 rounded-xl bg-card border border-border hover:border-blue-500/20 transition-colors text-left"
                >
                  <span className="text-foreground font-medium text-sm pr-4">{item.q}</span>
                  <ChevronDown
                    className={`w-4 h-4 text-muted-foreground shrink-0 transition-transform duration-200 ${
                      openIndex === i ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <AnimatePresence>
                  {openIndex === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.2 }}
                      className="overflow-hidden"
                    >
                      <p className="px-5 py-4 text-muted-foreground text-sm leading-relaxed">
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
